import { googleAnalyticsParamEvent, googleAnalyticsEvent } from '../utils/googleAnalyticsEvents';

export const modalService = {
    state() {
        return {
            exclusiveServiceModal: false,
            announcementModalOpen: false,
            announcementPayload: {
                id: 'policy-update-2026-02-09',
                active: true,
                title: 'Atualização dos Termos de Uso do LG Family Club',
                ctaLabel: 'Confirmar',
                body: [
                    {
                        text: 'Atualizamos os Termos de Uso da Comunidade LG Family Club para reforçar as regras de participação, conduta e moderação dentro da plataforma. Essas alterações tornam a experiência mais segura, transparente e alinhada às Diretrizes da Comunidade.'
                    },
                    {
                        text: 'Nenhuma ação adicional é necessária por parte dos usuários,<br>basta continuar utilizando o portal normalmente.'
                    },
                    {
                        text: 'Recomendamos que você leia atentamente as novas regras de<br>conduta disponíveis em ',
                        link: {
                            label: 'Termos & Condições',
                            toKey: 'footer.termsOfUse.url'
                        },
                        suffix: '.'
                    },
                    {
                        text: 'Ao confirmar você reconhece estar ciente das atualizações. <br> Acesse aqui os ',
                        link: {
                            label: 'Termos de Uso atualizados',
                            toKey: 'footer.termsOfUse.url'
                        },
                        suffix: '.'
                    }
                ]
            }
        }
    },
    mutations: {
        updateModalExclusiveService(state, value) {
            state.exclusiveServiceModal = value
        },
        updateAnnouncementModal(state, value) {
            state.announcementModalOpen = value
        },
        updateAnnouncementPayload(state, payload) {
            state.announcementPayload = {
                ...state.announcementPayload,
                ...(payload || {})
            }
        }
    },
    actions: {
        exclusiveServiceModal({ commit, state }) {
            googleAnalyticsEvent()
            commit('updateModalExclusiveService', !state.exclusiveServiceModal)
        },
        openAnnouncementModal({ commit }, payload) {
            if (payload) {
                commit('updateAnnouncementPayload', payload)
            }
            commit('updateAnnouncementModal', true)
        },
        closeAnnouncementModal({ commit }) {
            commit('updateAnnouncementModal', false)
        }
    },
    getters: {
        exclusiveServiceModalOpened: state => state.exclusiveServiceModal,
        announcementModalOpened: state => state.announcementModalOpen,
        announcementModalPayload: state => state.announcementPayload
    }
}
